import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import {
    List,
    ListItem,
    ListItemAvatar,
    Button,
    ListItemText,
    CircularProgress,
    Paper
} from '@material-ui/core';
import ProgressiveImage from 'react-progressive-image';
import ContentLoader from 'react-content-loader';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import { getBookingStatusClass } from '../../utils/config/constants.js';
import { KeyboardArrowDown, FilterList } from '@material-ui/icons';
import { withRouter } from 'react-router-dom';
import MenuButton from '../Menu/MenuButton.js';
import {
    BOOKING_VIEW_ALL,
    BOOKING_VIEW_INPROGRESS,
    BOOKING_VIEW_NEW,
    BOOKING_VIEW_COMPLETED,
    BOOKING_VIEW_CANCELLED
} from '../../utils/config/constants';
import { store } from '../../store';
const styles = theme => ({
    root: {
        width: '100%'
    },
    inline: {
        display: 'inline'
    },
    margin: {
        margin: theme.spacing.unit
    },
    extendedIcon: {
        marginRight: theme.spacing.unit
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        marginBottom: '10px'
    }
});
var isMounted = false;
class BookingList extends React.Component {
    constructor(props) {
        super();
        this.state = {
            page: 1,
            scrollClicked: false,
            detailRender: false,
            bookingSelected: '',
            showScroll: true
        };
    }
    componentDidMount() {
        isMounted = true;
        this.getData();
    }
    getData = () => {
        if (isMounted) {
            this.props.bookingListAction({
                page: this.state.page,
                append: false
            });
        }
    };
    componentWillUnmount() {
        isMounted = false;
    }

    renderPromoImage = () => {
        return (
            <div style={{ width: 200, height: 200 }}>
                <ContentLoader
                    height={200}
                    width={200}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="2" ry="2" width="200" height="200" />
                </ContentLoader>
            </div>
        );
    };
    handlePageChange = () => {
        this.setState(
            function(previousState) {
                return {
                    page: previousState.page + 1,
                    scrollClicked: true
                };
            },
            () => {
                this.setState({ scrollClicked: false });
                this.props.bookingListAction({
                    page: this.state.page,
                    append: true
                });
            }
        );
    };
    renderScrollIcon = () => {
        if (this.state.scrollClicked) {
            return <CircularProgress />;
        } else {
            return (
                <Button variant="fab" color="primary">
                    <KeyboardArrowDown onClick={this.handlePageChange} />
                </Button>
            );
        }
    };
    renderDetail = key => {
        this.setState({ detailRender: true, bookingSelected: key });
    };
    actionCallbacks = action => {
        if (action == BOOKING_VIEW_ALL) {
            this.setState({ showScroll: true });
        } else {
            this.setState({ showScroll: false });
        }
        this.props.bookingListAction({ type: action, append: false });
    };
    render() {
        const { bookingData, classes, match } = this.props;
        const { formatMessage } = this.props.intl;
        const { page } = this.state;
        if (this.state.detailRender) {
            this.props.history.push({
                pathname: `/user/booking/detail/${this.state.bookingSelected}`,
                bookingId: this.state.bookingSelected
            });
        }
        return (
            <div className="tz-2-com tz-2-main">
                <h4 className="d-flex justify-align-between">
                    <FormattedMessage
                        id="myBookings"
                        defaultMessage="My Bookings"
                    />{' '}
                    <div className="filter-btn">
                        <MenuButton
                            items={[
                                {
                                    action: BOOKING_VIEW_ALL,
                                    label: formatMessage({
                                        id: 'booking.allbookings'
                                    })
                                },
                                {
                                    action: BOOKING_VIEW_NEW,
                                    label: formatMessage({
                                        id: 'booking.newbookings'
                                    })
                                },
                                {
                                    action: BOOKING_VIEW_INPROGRESS,
                                    label: formatMessage({
                                        id: 'booking.inprogress'
                                    })
                                },
                                {
                                    action: BOOKING_VIEW_COMPLETED,
                                    label: formatMessage({
                                        id: 'booking.completedbookings'
                                    })
                                },
                                {
                                    action: BOOKING_VIEW_CANCELLED,
                                    label: formatMessage({
                                        id: 'booking.cancelledbookings'
                                    })
                                }
                            ]}
                            menuId={'bookingMenu'}
                            menuCallback={action =>
                                this.actionCallbacks(action)
                            }
                            iconType={FilterList}
                        />
                    </div>
                </h4>
                <div className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            {bookingData.length > 0 ? (
                                <List
                                    className={classes.root + ' list-check-out'}
                                >
                                    {bookingData.map(booking => {
                                        return (
                                            <ListItem
                                                key={booking.key}
                                                className={
                                                    classes.paper +
                                                    ' home-list-pop list-spac list-check-out-inn'
                                                }
                                            >
                                                <div className="col-md-3 dashboard-booklist-img">
                                                    <ListItemAvatar>
                                                        <ProgressiveImage
                                                            delay={2000}
                                                            src={
                                                                booking
                                                                    .bookingImage
                                                                    .medium
                                                            }
                                                            placeholder="provider-image"
                                                        >
                                                            {(src, loading) =>
                                                                loading ? (
                                                                    this.renderPromoImage()
                                                                ) : (
                                                                    <img
                                                                        width="200px"
                                                                        height="200px"
                                                                        src={
                                                                            src
                                                                        }
                                                                        alt="provider image"
                                                                    />
                                                                )
                                                            }
                                                        </ProgressiveImage>
                                                    </ListItemAvatar>
                                                </div>
                                                <div className="col-md-6">
                                                    <ListItemText
                                                        className=" home-list-pop-desc inn-list-pop-desc"
                                                        disableTypography={true}
                                                        primary={
                                                            <React.Fragment>
                                                                <h3>
                                                                    {
                                                                        booking.token
                                                                    }
                                                                </h3>
                                                                <h5>
                                                                    {
                                                                        booking
                                                                            .services[0]
                                                                            .service
                                                                    }
                                                                </h5>
                                                            </React.Fragment>
                                                        }
                                                        secondary={
                                                            <React.Fragment>
                                                                <h5>
                                                                    {
                                                                        booking.provider
                                                                    }
                                                                </h5>

                                                                <br />
                                                                {moment(
                                                                    booking.datetime
                                                                ).format(
                                                                    'DD-MMM-Y'
                                                                )}
                                                            </React.Fragment>
                                                        }
                                                    />
                                                </div>
                                                <div className="col-md-3 text-center">
                                                    <div
                                                        className={getBookingStatusClass(
                                                            booking.status
                                                        )}
                                                    >
                                                        {booking.status}
                                                    </div>
                                                    <Button
                                                        variant="contained"
                                                        size="large"
                                                        color="primary"
                                                        className={
                                                            classes.margin
                                                        }
                                                        onClick={() =>
                                                            this.renderDetail(
                                                                booking.key
                                                            )
                                                        }
                                                    >
                                                        <FormattedMessage
                                                            id="viewDetail"
                                                            defaultMessage="View Detail"
                                                        />
                                                    </Button>
                                                </div>
                                            </ListItem>
                                        );
                                    })}
                                </List>
                            ) : (
                                <div>
                                    <Paper>
                                        <p
                                            style={{
                                                color: '#000',
                                                padding: '10px'
                                            }}
                                        >
                                            <FormattedMessage
                                                id="noBookingFound"
                                                defaultMessage="No Booking found"
                                            />
                                        </p>
                                    </Paper>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="text-center">
                    {this.state.showScroll && this.renderScrollIcon()}
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ bookings }) => {
    return {
        bookingData: bookings.bookingData.bookingList,
        bookingLoader: bookings.bookingLoader
    };
};
const composedComponent = compose(
    withStyles(styles),
    connect(
        mapStateToProps,
        actions
    )
);
export default composedComponent(injectIntl(withRouter(BookingList)));



// WEBPACK FOOTER //
// ./src/components/Customer/BookingList.jsx